import React, { useEffect, useState } from "react";
import { Database, CheckCircle, XCircle, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, SectionCard } from "@/components/Primitives";

export default function EHRBridge() {
  const [integrations, setIntegrations] = useState([]);
  const [patients, setPatients] = useState([]);
  const [selectedPid, setSelectedPid] = useState("");
  const [timeline, setTimeline] = useState([]);

  useEffect(() => {
    api.get("/ehr/integrations").then(r=>setIntegrations(r.data));
    api.get("/patients").then(r=>{ setPatients(r.data); if(r.data[0]) setSelectedPid(r.data[0].id); });
  }, []);

  useEffect(() => {
    if (selectedPid) api.get(`/ehr/timeline/${selectedPid}`).then(r=>setTimeline(r.data));
  }, [selectedPid]);

  const icon = (s) => s==="connected"?<CheckCircle className="w-4 h-4 text-emerald-600" />:s==="disconnected"?<XCircle className="w-4 h-4 text-red-500" />:<Clock className="w-4 h-4 text-amber-500" />;

  return (
    <>
      <PageHeader eyebrow="Module 7" title="EHR Bridge"
        subtitle="Connected systems and a unified patient timeline across encounters, referrals and claims." testid="ehr-page" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {integrations.map(i => (
          <div key={i.name} className="kpi-card" data-testid={`ehr-${i.name}`}>
            <div className="flex items-center justify-between mb-3">
              <Database className="w-5 h-5 text-brand-primary" />
              {icon(i.status)}
            </div>
            <div className="text-lg font-semibold">{i.name}</div>
            <div className="text-xs text-brand-muted mt-0.5 capitalize">{i.status}</div>
            <div className="text-[11px] text-brand-muted mt-3">{i.patients_synced} patients synced</div>
          </div>
        ))}
      </div>

      <SectionCard title="Unified Patient Timeline" testid="timeline"
        actions={
          <select value={selectedPid} onChange={(e)=>setSelectedPid(e.target.value)} className="text-xs px-2 py-1.5 border border-brand rounded-md bg-white" data-testid="timeline-patient">
            {patients.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        }>
        {timeline.length === 0 ? (
          <div className="text-sm text-brand-muted py-8 text-center">No timeline data</div>
        ) : (
          <div className="space-y-3">
            {timeline.map((e, i)=>(
              <div key={i} className="flex gap-4 pb-3 border-b border-brand last:border-0">
                <div className="w-2 h-2 rounded-full bg-brand-primary mt-2 shrink-0"></div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <div className="text-sm font-medium text-brand-text">{e.title}</div>
                    <div className="text-xs text-brand-muted">{new Date(e.date).toLocaleDateString()}</div>
                  </div>
                  <div className="text-xs text-brand-muted mt-0.5 capitalize">{e.type}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </SectionCard>
    </>
  );
}
